import React from 'react'

const Error = () => {
    return (
        <>
            <div
                className='d-flex
                        flex-column
                        justify-content-around
                        align-items-center mx-auto'
                style={{
                    width: "40%"
                }}>
                <h1>
                    Bruh, U kinda Ran into an Error, plz lookout ;)
                </h1>
            </div>
        </>
    )
}

export default Error